import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function saveFaqsData(data) {
  console.log('faqService:::',data);
  // return false;
  return await api({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/admin/faqs/save-faqs`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
    data: data,
  });
}
export async function FetchFaqsList() {
  // console.log('faqServices:16');
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/faqs/faqs-list/`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}

export async function getFaqsRow(id) {
  console.log('faqService::getFaqsRow:44',id);

    return await api({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/admin/faqs/get-faqs-row/${id}`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
    });
}

export async function updateFaqsData(data) {
  console.log('faqService::updateFaqsData:52',data);
  //return false;
    return await api({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/admin/faqs/update-faqs`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
      data: data,
    });
}

export async function DeleteFaqsRecord(id) {
  console.log('faqsServices:24',id);
 return await api({
   method: "get",
   data: id,
   url: `${process.env.REACT_APP_API_URL}/admin/faqs/delete-faqs/${id}`,
   headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
 });
}

// Faqs Category
export async function saveFaqsCategoryData(data) {
  console.log('faqService::saveFaqsData:52',data);
    //return false;
    return await api({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/admin/faqs/save-faqs-category`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
      data: data,
    });
}

export async function getFaqsCategoryData() {
    return await api({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/admin/faqs/get-faq-category`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
    });
}

export async function getFaqsCategoryRow(id) {
  console.log('faqService::getFaqsCategoryRow:65',id);

    return await api({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/admin/faqs/get-faqscategory-row/${id}`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
    });
}
export async function updateFaqsCategoryData(data) {
  console.log('faqService::updateFaqsData:52',data);
  //return false;
    return await api({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/admin/faqs/update-faqs-category`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
      data: data,
    });
}

export async function DeleteFaqsCategoryRecord(id) {
  //console.log('faqsServices:24',id);
  return await api({
    method: "get",
    data: id,
    url: `${process.env.REACT_APP_API_URL}/admin/faqs/delete-faqs-category/${id}`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}
